import React, {Fragment} from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";
import LexicalRichTextEditor from "../UI/LexicalRichTextEditor";
import SpinnerDiv from "ui/SpinnerDiv";
import {checkError} from 'root/DataFunctions/BaseDataFns'

import he from 'he';
import BootstrapRow from "ui/BootstrapRow";

export default class PEPSocialWorkerNotesForm extends MultiPageForm
{
	constructor(props) 
	{
		super(props);

		this.state.mode = this.props.mode ;

		if ( this.props.data != null )
		{
			this.state.data = this.props.data ;
			this.state.loading = false ;
		}
		else
		{
			if ( this.props.pep_id != null )
			{
				this.state.pep_id = props.pep_id ;
				this.state.loadingnotes = true ;
				this.state.loadingtransitions = true ;
			}
			else
			{
				this.state.loading = false ;
			}
		}
		
		this.keyCount = 1 ;

		this.doPrevButton = this.doPrevButton.bind(this); 
		this.onLeave = this.onLeave.bind(this);

		this.edit1 = React.createRef();

		if ( props.subscribe != null )
		{
			props.subscribe(this) ;
		}

		if (props.register !== undefined)
		{
			props.register('swnotes',
				{
					setDirty: this.setDirty.bind(this),
					onLeave: this.onLeave.bind(this),
					getFormData: this.getFormData.bind(this),
					formIsValid: this.formIsValid.bind(this),
					autoSave: this.autoSave.bind(this)
				})
		}

		if ( this.state.loadingnotes === true && this.props.mode === 'edit' || this.props.mode === 'view' || this.props.mode === 'qa' )
		{
			this.getNotes ( this.state.pep_id ) ;
		}
	}

	setPageDecoratorStatus ( flag )
	{
		if ( this.props.setSWTabDecorator !== null && this.props.setSWTabDecorator !== undefined )
		{
			if ( flag === true )
			{
				this.props.setSWTabDecorator( 'glyphicon-warning-sign' ) ;
			}
			else
			{
				this.props.setSWTabDecorator( null ) ;
			}
		}
	}

	getNotes ( pep_id )
	{
		var url = Globals.APIFolder + '/peps/' + pep_id + '/socialworkernotes'
		
    	$.ajax({
    		  type: 'GET',
    		  url: url ,
    		  data: {},
    		  success:(data)=>{

      			if ( checkError ( data ))
				{
                    let displayText = '' ;
                    let htmlText = null ;
					let html = null ;

					const status = data.status ;

    				if ( status.rowsAffected == 1 )
					{
                        displayText = data.data[0].notes ;
                        htmlText = data.data[0].html ;
					}
					else
					{
						data.data = [] ;
						data.data[0] = {} ;
						data.data[0].notes = null ;
                        data.data[0].html = null ;
					}

                    if ( htmlText == null )
					{
                        if ( displayText != null )
                        {
                            htmlText = displayText ;

                            htmlText = htmlText.replace(/\\r/g, "<br>");
                            htmlText = htmlText.replace(/\\n/g, "<br>");

                            html = htmlText ;

                            displayText = displayText.replace(/\\r/g, "\r");
                            displayText = displayText.replace(/\\n/g, "\n");
                        }
					}
                    else
                    {
                        displayText = displayText.replace(/\\r/g, "\r");
                        displayText = displayText.replace(/\\n/g, "\n");

                        html = he.decode (htmlText) ;

                    }

    				data.data[0].notes = displayText ;

					if ( html === null )
					{
						this.setPageDecoratorStatus( true ) ;
					}

	  				this.setState({ loadingnotes: false, data: data.data[0], html: html });
    			}
    		  },
    		  error:(jqXHR, textStatus, error)=>{
    		  	handleAjaxError(jqXHR, textStatus, error);
			  }
    		});

	}

	putNotes( postdata, onSaveCompleteCallback )
	{
		let url = Globals.APIFolder + '/peps/' + postdata.pep_id + '/socialworkernotes/' + postdata.pep_notes_id ;
		
    	$.ajax({
    		  type: 'PUT',
    		  url: url ,
    		  data: { data: postdata },
    		  success:(data)=>{
    		  	if ( checkError (data))
				{
                    this.setDirty ( false ) ;

                    if ( onSaveCompleteCallback != null )
					{
						onSaveCompleteCallback( postdata ) ;
					}
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>{

				handleAjaxError(jqXHR, textStatus, error) ;
	  			}
    		});

	}

	sendReminder( onReminderSentCallback )
	{
		let message = "You are about to send a reminder to the Social Worker. <br/><br/>Are you sure you want to do this?"
		let me  = this ;
		bootbox.confirm({
			message: message,
			buttons: {
				confirm: {
					label: 'Yes, Send it',
					className: 'btn-success'
				},
				cancel: {
					label: 'Cancel',
					className: 'btn-default'
				}
			},
			callback: function (result)
			{
				if ( result === true )
				{
					let url = Globals.APIFolder + '/peps/' + me.props.pep_id + '/feedbackremind' ;

					$.ajax({
						type: 'PUT',
						url: url ,
						success:(data)=>{
							if ( checkError (data))
							{
							}
						},
						error:(jqXHR, textStatus, error)=>{

							handleAjaxError(jqXHR, textStatus, error) ;
						}
					});
				}
			}
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////////
	// THE FOLLOWING FUNCTIONS MUST BE PRESENT TO SUPPORT editing using the EditablePanelWrapper CLASS
	/////////////////////////////////////////////////////////////////////////////////////////////////////
	onClickEdit()
	{
		this.setState ( {mode: 'modify'});
	}

	onClickCancelEdit()
	{
		this.setState ( {mode: this.props.mode});
	}

	onSaveComplete( data )
	{
		this.setState ( { mode: this.props.mode, html: data.html }) ;
	}

	doSave( onSaveCompleteCallback )
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			const data = this.getFormData() ;

			this.putNotes (data.notes, onSaveCompleteCallback ) ;
		}
	}
	/////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////

	onLeave()
	{
		if ( this.props.autoSave === true )
		{
			this.autoSave() ;
		}
	}

	onEnter()
	{
	}
	
	isDirty()
	{
		return this.edit1.current.isDirty() ;
	}
	
	setDirty ( value )
	{
		this.edit1.current.setDirty( value ) ;
	}

    onChange()
    {
        this.setDirty (true) ;
    }

	autoSave()
	{
		if ( this.isDirty() )
		{
			this.doSave( null ) ;
		}
	}
	
	getFormData()
	{
		return { notes: {
					html: this.edit1.current.getData(),
					pep_id: this.state.data.pep_id,
					pep_notes_id: this.state.data.pep_notes_id
				}} ;
	}
	
	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.onSave != null )
			{
				this.props.onSave() ;
			}	
		}
	}

	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}
	}
	
	doPrevButton()
	{
		if ( this.props.navigationNotifier != null )
		{
			if ( this.props.autoSave == true )
			{
				this.autoSave() ;
			}

			this.props.navigationNotifier ( 'prev' ) ;
		}
	}

	sendReminderRow = () =>
	{
		let txt ;

		if ( this.props.isPost16 )
		{
			txt = "There is currently no Social Care feedback for this Young Person's PEP." ;
		}
		else
		{
			txt = "The Social Worker has not yet contributed to this pupil's PEP." ;
		}

		return (
			<BootstrapRow>
				<div className='col-md-10' style={{color: 'blueviolet'}}>{txt}</div>
				<div className='col-md-2'>
					<button onClick={this.sendReminder.bind(this)} id="ChangeButton" type="button" className="btn btn-sm btn-info" style={{float: 'right', marginRight: '15px'}}>Send Reminder</button>
				</div>
			</BootstrapRow>
		)
	}

	rowNotesTitle ()
	{
		let txt ;

		if ( this.props.isPost16 )
		{
			txt = "Social carer feedback" ;
		}
		else
		{
			txt = "Social worker feedback" ;
		}

		var lineList=[];

		lineList.push( React.createElement ( 'div',{key: 'divEdit1Col1', className: 'col-md-12'},
			React.createElement ( 'span', { style: { fontWeight: 'bold'}}, txt))) ;

		lineList.push( React.createElement ( 'div',{key: 'divEdit1Col2', className: 'col-md-12', style: { marginBottom: '5px'}},
			React.createElement ( 'span', { style: { fontStyle: 'italic'}}, "For example: How long have you been this pupil's social worker, Do they talk about school positively? what do they like to do at school and outside school. ")));

		return  React.createElement ( 'div' , { key: 'divNotesTitleRow', className: 'row' } , lineList );
	}

	rowHTMLNotes ()
    {
        var lineList=[];

        const config = { height: 500 };

        const events = { change: this.onChange.bind(this) };

        lineList.push ( React.createElement ( 'div',{key: 'divEdit1Col', className: 'col-md-12'},
            React.createElement ( LexicalRichTextEditor, {key: 'edit1' + this.keyCount , ref: this.edit1, config: config, events: events, value: this.state.html } ))) ;

        return  <div key='divEdit1Row' className='row'>{lineList}</div>
    }

	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	buttonRow ()
    {
        var lineList=[];
        
        if ( this.props.mode === 'view')
        {
			return (
				<Fragment>
					<div className='col-md-9' />
					<div className='col-md-3' style={{ paddingRight: '0px'}}>
						<button id='CloseButton' type='button' className='btn btn-secondary' style={{float: 'right', marginRight: '0px' }} onClick={this.onCancel.bind(this)}>Close</button>
					</div>
				</Fragment>
			)
        }
        else
		{
			return (
				<Fragment>
					<div className='col-md-9'/>
					<div className='col-md-3' style={{paddingRight: '0px'}}>
						<button id='SaveButton' type='button' className='btn btn-primary' style={{float: 'right'}}
								onClick={this.onSave.bind(this)}>Save
						</button>
						<button id='CancelButton' type='button' className='btn btn-secondary'
								style={{float: 'right', marginRight: '10px'}} onClick={this.onCancel.bind(this)}>Close
						</button>
					</div>
				</Fragment>
			)
		}
    }

	panelContent()
	{
		return (
			<Fragment>
				{this.state.html === null && this.props.suppressReminderButton !== true && this.sendReminderRow()}
				{this.rowNotesTitle()}
				{this.rowHTMLNotes()}
			</Fragment>
		)
	}

	readOnlyPanelContent()
	{
		let txt ;

		if ( this.props.isPost16 )
		{
			txt = "Social carer feedback" ;
		}
		else
		{
			txt = "Social worker feedback" ;
		}

		return (
			<Fragment>
				<div className='col-md-12' key='divEdit1Col1'>
					<span style={{ fontWeight: 'bold'}}>{txt}</span>
				</div>
				<div className='col-md-12' key='divEdit1Col2' style={{ marginBottom: '5px', marginTop: '10px'}}>
					<span style={{ fontWeight: 'bold'}} className='html-italic' dangerouslySetInnerHTML={{ __html: this.state.html }} />
				</div>
			</Fragment>
		)
	}

	formRows ()
	{
		if ( this.state.mode === 'qa')
		{
			return <div key='sw-readonly' className='row'>{this.readOnlyPanelContent()}</div>
		}
		else
		{
			return (
				<Fragment>
					<div key='sw-edit' className='row panel-body'>
						<div key='sw-edit-panel' className='col-md-12'>
							{this.panelContent()}
						</div>
					</div>
					{ this.props.showButtons === true &&
					<div key='buttons' className='panel-body'>
						{this.buttonRow()}
					</div> }
					{this.navFormRow()}
				</Fragment>
			)
		}
	}
	
	render() 
    {
		this.keyCount=0;
		
    	if ( this.state.loadingnotes === true)
    	{
	        return <SpinnerDiv />
    	}
    	else
    	{
			return <div key='swdiv' className='panel panel-default panel-noborder'>{this.formRows()}</div>;
    	}
    }
};